// ==============================================================================
// Avec API — Configuração de credenciais
// ==============================================================================
//
// O token do módulo franquia fica SÓ no servidor (env AVEC_TOKEN da Vercel) e é
// enviado pelo proxy /api/avec no header "Authorization" de cada requisição.
//
// ⚠️ SEGURANÇA (07/10/2026): o TOKEN do Avec NÃO fica mais no navegador.
// Toda chamada passa pelo proxy /api/avec, que usa o token do SERVIDOR
// (AVEC_TOKEN). Antes, este arquivo lia a variável VITE_ do token e o
// Vite embutia o token no JavaScript público do site — qualquer pessoa podia
// copiá-lo e chamar a Avec direto, pulando os portões do proxy. NUNCA voltar a
// ler uma variável VITE_* com segredo aqui.
// ==============================================================================

export const AVEC_CONFIG = {
  // ID da franquia (opcional — usado em alguns relatórios como 2009)
  franquiaId: import.meta.env.VITE_AVEC_FRANQUIA_ID || '',

  // ID da unidade (opcional — filtra relatório para uma unidade específica)
  // Se vazio, relatórios trazem dados de todas as unidades da franquia
  salaoUnidadeId: import.meta.env.VITE_AVEC_UNIDADE_ID || '',

  // Base URL — não mudar (vem do catálogo oficial da Avec)
  baseUrl: 'https://api.avec.beauty',

  // Timeout de requisição em ms
  timeout: 30000,

  // Limite máximo de registros por página (Avec permite até 250)
  maxPageSize: 250,
};

// A integração está ligada? O token mora no servidor (o proxy responde erro se
// ele faltar). Desligar no navegador sem segredo: VITE_AVEC_DESLIGADO=1.
export function isAvecConfigured() {
  return import.meta.env.VITE_AVEC_DESLIGADO !== '1';
}
